import React from 'react';
import { translate } from 'react-i18next';

const Footer = ({ t }) => (
  <footer className="c-footer">
    <div className="o-wrapper o-wrapper--large u-text-center u-padding-vertical-large">
      <p className="c-footer__text u-padding-bottom-tiny">
        {t('footer.note')}
        <a
          href="https://docs.google.com/forms/d/e/1FAIpQLSezkQ_TS-qATBwjHk76PxJ_ydcS4T5b7NPspqNHOTiIlFBIvg/viewform"
          target="_blank"
          rel="noopener noreferrer"
          className="c-footer__link"
        >
          {t('footer.noteCallToAction')}
        </a>
      </p>
      <p className="c-footer__text">
        {t('footer.createdBy')}{' '}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://devlabs.bg"
          className="c-footer__link"
        >
          {t('footer.createdByUrl')}
        </a>
        .
      </p>
    </div>
  </footer>
);

export default translate()(Footer);



// WEBPACK FOOTER //
// ./src/common/Footer.js